import Vue from 'vue'
import Router from 'vue-router'
import Products from './Views/Products.vue'
import Categories from './Views/Categories.vue'
import Contact from './Views/Contact.vue'
import Questions from './Views/Questions.vue'
import Checkout from "./Views/Checkout/Checkout";
import NotFound from './Views/Errors/404';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'categories',
            component: Categories
        },
        {
            path: '/category/:id/products',
            name: 'products',
            component: Products
        },
        {
            path: '/category/:id/product/:pid/questions',
            name: 'questions',
            component: Questions
        },
        {
            path: '/checkout',
            name: 'checkout',
            component: Checkout
        },
        {
            path: '/contact',
            name: 'contact',
            component: Contact
        },
        {
            path: '*',
            name: '404',
            component: NotFound
        }

    ]
});
